import reduce from 'lodash/reduce'
import URI from 'urijs'
import type { SearchParamsAttributes } from '@pc/components/Works/Panel/types'

type ParameterApiCompatTable = Record<
  string,
  {
    shortKey: string
    multiple: boolean
  }
>

const PARAMETER_API_COMPAT_TABLE: ParameterApiCompatTable = {
  free_word: { shortKey: 'fw', multiple: false },
  keywords: { shortKey: 'kw', multiple: false },
  station_ids: { shortKey: 'si', multiple: true },
  town_ids: { shortKey: 'ti', multiple: true },
  city_ids: { shortKey: 'ci', multiple: true },
  brand_ids: { shortKey: 'bi', multiple: true },
  jobtag_ids: { shortKey: 'jti', multiple: true },
  custom_codes: { shortKey: 'cc', multiple: true },
  salary_amount: { shortKey: 'sa', multiple: false },
  company_search_ids: { shortKey: 'csi', multiple: true },
  company_ids: { shortKey: 'coi', multiple: true },
  work_ids: { shortKey: 'wi', multiple: true },
  job_type_ids: { shortKey: 'ji', multiple: true },
  line_ids: { shortKey: 'li', multiple: true },
  job_codes: { shortKey: 'jc', multiple: true },
  features: { shortKey: 'ft', multiple: true },
  welcome: { shortKey: 'wc', multiple: false },
  keepup_day: { shortKey: 'kd', multiple: false },
  keepup_hour: { shortKey: 'kh', multiple: false },
  time_slots: { shortKey: 'ts', multiple: true },
  sort_key: { shortKey: 'sk', multiple: false },
  area_codes: { shortKey: 'ac', multiple: true },
  prefecture_id: { shortKey: 'pi', multiple: true },
  accept_highschool_students: { shortKey: 'ahs', multiple: false },
  accept_students: { shortKey: 'as', multiple: false },
  except_right_highschool_education: { shortKey: 'ehe', multiple: false },
  except_right_college_education: { shortKey: 'ece', multiple: false },
  except_medical_services: { shortKey: 'ems', multiple: false },
  except_haken: { shortKey: 'eh', multiple: false },
  except_night_work: { shortKey: 'enw', multiple: false },
  working_time: { shortKey: 'wt', multiple: true }
}

const COUNT_API_PATH = '/search/count'
const DYNAMIC_SEARCH_PATH = '/works'

const buildWorkSearchApiQuery = (params: SearchParamsAttributes) => {
  const queries: ParameterApiCompatTable = reduce(
    params,
    (result, searchValue, searchKey) => {
      const compatKeyInfo = PARAMETER_API_COMPAT_TABLE[searchKey]

      if (compatKeyInfo === undefined) {
        return result
      }

      const multipleSuffix = compatKeyInfo.multiple ? '[]' : ''
      const queryKey = `q[${compatKeyInfo.shortKey}]${multipleSuffix}`

      return { ...result, [queryKey]: searchValue }
    },
    {}
  )
  return URI().query(queries).query()
}

const buildWorkSearchApiUrl = (url: string, params: SearchParamsAttributes) => {
  const apiParams = buildWorkSearchApiQuery(params)
  const endPoint = URI(url).query(apiParams).toString()
  return endPoint
}

const buildDynamicSearchApiUrl = (params: SearchParamsAttributes) => {
  return buildWorkSearchApiUrl(DYNAMIC_SEARCH_PATH, params)
}

const buildWorkCountApiUrl = (params: SearchParamsAttributes) => {
  return buildWorkSearchApiUrl(COUNT_API_PATH, params)
}

export { buildDynamicSearchApiUrl, buildWorkCountApiUrl }
